<template>
	<div>
		<!-- <top></top> -->
		<div class="city">
			<div class="flex margin-top-sm">
				<p class="text-333 text-df margin-right-sm">常用城市：</p>
				<p>
					<span class="pointer common-city margin-right-xs" v-for="(item,index) in common" :key="index">{{item.name}}</span>
				</p>
			</div>
			<div class="flex align-center margin-top-sm">
				<p class="text-333 text-df margin-right-sm">直接搜索：</p>
				<div class="flex align-center entry padding-left-xs">
					<input type="" v-model="seach" name="" id="" value="" placeholder="请输入关键词..." style="background-color: #FFF;"/>
					<div class="btns flex align-center justify-center">
						<img src="../../assets/img/seach-icon.png" >
						<p class="text-white">搜索</p>
					</div>
				</div>
			</div>
			<div class="margin-bottom">
				<p class="title text-left margin-top margin-bottom-sm">按拼音首字母选择</p>
				<div class="chart">
					<div class="flex" v-for="(item,index) in city" :key="index">
						<p class="letter flex solid-left flex-direction justify-center align-center solid-bottom">{{item.letter}}</p>
						<p class="city-item bg-white solid-bottom flex-sub text-left ">
							<span class="margin-right-xs pointer" @click="chose(ele)" v-for="(ele,iaxs) in item.childer" :key="iaxs">{{ele.name}}</span>
						</p>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	import Top from '@/components/public/top.vue';
	export default {
		components: {
			Top
		},
		name: '',
		data() {
			return {
				seach:'',//搜素字段
				common:[
					{
						name:'全国'
					},{
						name:'北京'
					},{
						name:'天津'
					},{
						name:'大连'
					},
				],//常用城市
				city:[
					{
						letter:'A',
						childer:[
							{
								name:'安顺'
							},{
								name:'安庆'
							},{
								name:'阿勒泰'
							},{
								name:'阿盟'
							},{
								name:'阿克苏'
							},{
								name:'安康'
							},{
								name:'阿坝'
							},{
								name:'鞍山'
							},{
								name:'安阳'
							}
						]
					},{
						letter:'B',
						childer:[
							{
								name:'北京'
							},{
								name:'保定'
							},{
								name:'巴彦淖尔'
							},{
								name:'滨州'
							},{
								name:'百色'
							},{
								name:'毕节'
							},{
								name:'本溪'
							},{
								name:'保山'
							},{
								name:'白银'
							},{
								name:'博州'
							},{
								name:'包头'
							},{
								name:'巴州'
							},{
								name:'白山'
							},{
								name:'蚌埠'
							},{
								name:'北海'
							},{
								name:'白城'
							},{
								name:'巴中'
							},{
								name:'宝鸡'
							},
						]
					},{
						letter:'C',
						childer:[
							{
								name:'重庆'
							},{
								name:'广州'
							},{
								name:'郑州'
							},{
								name:'成都'
							},{
								name:'长春'
							},{
								name:'常德'
							},{
								name:'池州'
							},{
								name:'昌吉'
							},{
								name:'长治'
							},{
								name:'常州'
							},{
								name:'巢湖'
							},{
								name:'长沙'
							},{
								name:'承德'
							},{
								name:'潮州'
							},{
								name:'沧州'
							},{
								name:'滁州'
							},{
								name:'郴州'
							},{
								name:'赤峰'
							},{
								name:'朝阳'
							},{
								name:'崇左'
							},{
								name:'楚雄'
							},
						]
					},{
						letter:'D',
						childer:[
							{
								name:'东莞'
							},{
								name:'德阳'
							},{
								name:'大理'
							},{
								name:'丹东'
							},{
								name:'达州'
							},{
								name:'德宏'
							},{
								name:'定西'
							},{
								name:'大兴安岭'
							},{
								name:'大庆'
							},{
								name:'迪庆'
							},{
								name:'东营'
							},{
								name:'德州'
							},{
								name:'大连'
							},{
								name:'大同'
							}
						]
					},{
						letter:'E',
						childer:[
							{
								name:'鄂州'
							},{
								name:'恩施'
							},{
								name:'鄂尔多斯'
							}
						]
					},{
						letter:'F',
						childer:[
							{
								name:'福州'
							},{
								name:'阜新'
							},{
								name:'抚顺'
							},{
								name:'阜阳'
							},{
								name:'抚州'
							},{
								name:'佛山'
							},{
								name:'防城港'
							}
						]
					},{
						letter:'G',
						childer:[
							{
								name:'甘孜'
							},{
								name:'赣州'
							},{
								name:'广安'
							},{
								name:'黄河农高区'
							},{
								name:'固原'
							},{
								name:'广元'
							},{
								name:'果洛'
							},{
								name:'高新区'
							},{
								name:'贵港'
							},{
								name:'甘南'
							},{
								name:'贵阳'
							},{
								name:'桂林'
							}
						]
					},{
						letter:'H',
						childer:[
							{
								name:'哈尔滨'
							},{
								name:'合肥'
							},{
								name:'呼和浩特'
							},{
								name:'杭州'
							},{
								name:'海口'
							},{
								name:'哈密'
							},{
								name:'鹤壁'
							},{
								name:'菏泽'
							},{
								name:'海东'
							},{
								name:'黄冈'
							},{
								name:'韶关'
							},{
								name:'贺州'
							},{
								name:'惠州'
							},{
								name:'兴安盟'
							},{
								name:'黄山'
							},{
								name:'黑河'
							},{
								name:'海北'
							},{
								name:'湖州'
							},{
								name:'汉中'
							},{
								name:'河池'
							},{
								name:'鹤岗'
							},{
								name:'黄南'
							},{
								name:'海南县'
							},{
								name:'淮安'
							},{
								name:'淮南'
							},{
								name:'衡阳'
							},{
								name:'河源'
							},{
								name:'衡水'
							},{
								name:'怀化'
							},{
								name:'葫芦岛'
							},{
								name:'邯郸'
							},{
								name:'黄石'
							},{
								name:'红河'
							},{
								name:'呼伦贝尔'
							},{
								name:'淮北'
							},{
								name:'和田'
							},{
								name:'海西'
							}
						]
					},{
						letter:'J',
						childer:[
							{
								name:'济宁'
							},{
								name:'嘉峪关'
							},{
								name:'荆州'
							},{
								name:'江汉油田'
							},{
								name:'金昌'
							},{
								name:'嘉兴'
							},{
								name:'鸡西'
							},{
								name:'酒泉'
							},{
								name:'吉安'
							},{
								name:'晋城'
							},{
								name:'焦作'
							},{
								name:'荆门'
							},{
								name:'揭阳'
							},{
								name:'锦州'
							},{
								name:'景德镇'
							},{
								name:'济源'
							},{
								name:'晋中'
							},{
								name:'金华'
							},{
								name:'江门'
							},{
								name:'九江'
							},{
								name:'佳木斯'
							},{
								name:'吉林'
							}
						]
					},{
						letter:'K',
						childer:[
							{
								name:'昆明'
							},{
								name:'开封'
							},{
								name:'克州'
							},{
								name:'克拉玛依'
							},{
								name:'喀什'
							}
						]
					},{
						letter:'L',
						childer:[
							{
								name:'拉萨'
							},{
								name:'兰州'
							},{
								name:'丽水'
							},{
								name:'泸州'
							},{
								name:'吕梁'
							},{
								name:'龙岩'
							},{
								name:'辽阳'
							},{
								name:'凉山'
							},{
								name:'柳州'
							},{
								name:'辽源'
							},{
								name:'六盘水'
							},{
								name:'丽江'
							},{
								name:'连云港'
							},{
								name:'莱芜'
							},{
								name:'来宾'
							},{
								name:'廊坊'
							},{
								name:'临沧'
							},{
								name:'临沂'
							},{
								name:'陇南'
							},{
								name:'洛阳'
							},{
								name:'漯河'
							},{
								name:'乐山'
							},{
								name:'临夏'
							},{
								name:'六安'
							},{
								name:'娄底'
							},{
								name:'聊城'
							},{
								name:'临汾'
							},{
								name:'林芝'
							}
						]
					},{
						letter:'M',
						childer:[
							{
								name:'茂名'
							},{
								name:'眉山'
							},{
								name:'牡丹江'
							},{
								name:'绵阳'
							},{
								name:'梅山'
							},{
								name:'马鞍山'
							}
						]
					},{
						letter:'N',
						childer:[
							{
								name:'南宁'
							},{
								name:'南京'
							},{
								name:'南平'
							},{
								name:'宁德'
							},{
								name:'南沙群岛'
							},{
								name:'那曲'
							},{
								name:'南通'
							},{
								name:'宁波'
							},{
								name:'怒江'
							},{
								name:'内江'
							},{
								name:'南阳'
							},{
								name:'南充'
							}
						]
					},{
						letter:'P',
						childer:[
							{
								name:'平凉'
							},{
								name:'盘锦'
							},{
								name:'濮阳'
							},{
								name:'普尔'
							},{
								name:'莆田'
							},{
								name:'萍乡'
							},{
								name:'平顶山'
							},{
								name:'攀枝花'
							}
						]
					},{
						letter:'Q',
						childer:[
							{
								name:'七台河'
							},{
								name:'庆阳'
							},{
								name:'黔西南'
							},{
								name:'黔东南'
							},{
								name:'黔南'
							},{
								name:'潜江'
							},{
								name:'钦州'
							},{
								name:'泉州'
							},{
								name:'清远'
							},{
								name:'曲靖'
							},{
								name:'秦皇岛'
							},{
								name:'青岛'
							}
						]
					},{
						letter:'R',
						childer:[
							{
								name:'日照'
							}
						]
					},{
						letter:'S',
						childer:[
							{
								name:'上海'
							},{
								name:'石家庄'
							},{
								name:'沈阳'
							},{
								name:'商丘'
							},{
								name:'神农架林'
							},{
								name:'上饶'
							},{
								name:'四平'
							},{
								name:'石嘴山'
							},{
								name:'宿迁'
							},{
								name:'山南'
							},{
								name:'深圳'
							},{
								name:'苏州'
							},{
								name:'朔州'
							},{
								name:'石河子'
							},{
								name:'绍兴'
							},{
								name:'随州'
							},{
								name:'汕尾'
							},{
								name:'双鸭山'
							},{
								name:'汕头'
							},{
								name:'遂宁'
							},{
								name:'松原'
							},{
								name:'宿州'
							},{
								name:'三明'
							},{
								name:'商洛'
							},{
								name:'邵阳'
							},{
								name:'三门峡'
							},{
								name:'三亚'
							},{
								name:'十堰'
							}
						]
					},{
						letter:'T',
						childer:[
							{
								name:'天津'
							},{
								name:'太原'
							},{
								name:'铜陵'
							},{
								name:'泰安'
							},{
								name:'塔城'
							},{
								name:'铜仁'
							},{
								name:'通化'
							},{
								name:'天水'
							},{
								name:'铁岭'
							},{
								name:'唐山'
							},{
								name:'通辽'
							},{
								name:'图木舒克'
							},{
								name:'铜川'
							},{
								name:'天门'
							},{
								name:'吐鲁番'
							},{
								name:'台州'
							}
						]
					},
				],//城市
				
			}
		},
		created() {
			Bus.$emit('chosename','home')
			// this.getCityList()
		},
		methods: {
			/**
			 * 获取首页用工分类
			 * */
			getCityList(){
				this.ajax('get', '/api/pc/work/getCityList', {}, res => {
					console.log(res);
				})
			},
			chose(ele){
				Bus.$emit('chagecity')
				// localStorage.setItem('city', ele.name);
				this.$store.commit('updatecity', ele.name);
				this.$router.push({
					name:'home',
					query: {
						
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.city{
		width: 1210px;
		margin: 0 auto;
		.common-city:hover{
			color: #09827B;
			border-bottom: 1px solid #09827B;
		}
		.entry{
			width: 736px;
			height: 41px;
			background: #FFFFFF;
			box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
			
			input{
				width: 630px;
				border: 0;
				 outline: 0;
			}
			.btns{
				width: 106px;
				height: 41px;
				background: #09827B;
				border-radius: 0px 6px 6px 0px;
			}
		}
		.title{
			font-size: 28px;
		}
		.chart{
			width: 100%;
		}
		.letter{
			min-width: 100px;
			background: rgb(247, 247, 247);
		}
		.city-item{
			padding-top: 24px;
			padding-left: 24px;
			padding-bottom: 24px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/tab/city.vue